module.exports = __webpack_public_path__ + "img/logo.fe31612c.png";